import { useState } from 'react';

export function useSubmitAccertamento() {
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (parameters) => {
    setLoading(true);
    setError(null);
    setReport(null);

    try {
      const response = await fetch('/api/ai/accertamento', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          parameters,
        }),
      });

      let data;

      try {
        data = await response.json();
      } catch {
        throw new Error('Risposta non valida dal server');
      }

      if (!response.ok) {
        throw new Error(
          data?.detail || 'Errore durante la richiesta all\'AI'
        );
      }

      if (!data?.report) {
        throw new Error('Il server non ha restituito un report');
      }

      setReport(data.report);

      return data.report;

    } catch (err) {
      console.error('Errore AI:', err);

      setError(
        err.message || 'Errore durante la richiesta AI'
      );

      return null;

    } finally {
      setLoading(false);
    }
  };

  return {
    submit,
    report,
    setReport,
    loading,
    error,
  };
}